<nz-tabset [nzSelectedIndex]="tabSelectedIndex"  (nzSelectedIndexChange)="onTabChange($event)">
    <nz-tab [nzTitle]="'ADDRESS_LIST' | translate">
        <cart-address [addressList]="addressList" (handleCloseAddress)="handleCloseModal()"
        (addressSelected)="handleAddressSelected($event)" ></cart-address>
    </nz-tab>
    <nz-tab [nzTitle]="'TEMPORARY_ADDRESS'| translate">
      <ng-template nz-tab>
        <edit-address (handleCloseAddress)="handleCloseModal()"
        (addressSelected)="handleAddressSelected($event)"></edit-address>
    </ng-template>
    </nz-tab>
</nz-tabset>
